import React from 'react';
import { withRouter } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from 'components/CustomButtons/Button.jsx';
import PageTitle from 'components/inc/PageTitle.jsx';
import LoadingComponent from 'components/inc/LoadingComponent';
import style from 'assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.jsx';
import { connect } from 'react-redux';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { getProjectDetails } from '../../../actions/project';
import { getSprintDetails } from '../../../actions/sprint';
import _ from 'lodash-es';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import SprintForm from './SprintForm';
import { Route, Switch } from 'react-router-dom';
import { Link } from 'react-router-dom';
import UserStories from '../UserStories';
import { getUserStories } from '../../../actions/userStories';
import StoryList from '../UserStories/StoryList';
import NewUserStory from '../UserStories/NewUserStory';
import SprintInfo from './SprintInfo';

class Sprint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isError: false,
    };
  }

  async componentDidMount() {
    console.log(this.props);
    const projectId = this.props.project._id;
    const sprintId = this.props.match.params.sprintid;

    //TODO: Move the sprint data exists check to the action
    await this.props.getSprintDetails(projectId, sprintId);

    console.log(projectId, sprintId);
    await this.props.getUserStories(projectId, sprintId);
    this.setState({
      isLoading: false,
    });
  }

  render() {
    console.log('Re rendered!!');
    const sprint = this.props.sprintData;
    console.log('Sprint', sprint);
    const projectId = this.props.project._id;
    const sprintId = this.props.match.params.sprintid;
    return (
      <div>
        {/* <PageTitle title={"Create New Sprint"} /> */}
        <LoadingComponent isLoading={this.state.isLoading}>
          {!this.state.isLoading && sprint && (
            <Switch>
              <Route exact path={`${this.props.match.path}/edit`}>
                <>
                  <PageTitle title={'Edit Sprint'} />
                  <SprintForm sprint={this.props.sprintData} />
                </>
              </Route>
              <Route exact path={`${this.props.match.path}/create-story`}>
                <>
                  <NewUserStory sprint={this.props.sprintData} />
                </>
              </Route>
              <Route
                exact
                path={`${this.props.match.path}/duplicate-story/:storyid`}
              >
                <>
                  <NewUserStory duplicate sprint={this.props.sprintData} />
                </>
              </Route>
              <Route exact path={`${this.props.match.path}/stories/:storyid`}>
                <>
                  <NewUserStory sprint={this.props.sprintData} />
                </>
              </Route>
              <Route exact path={`${this.props.match.path}/info`}>
                <>
                  <SprintInfo
                    sprint={this.props.sprintData}
                    project={this.props.project}
                  />
                </>
              </Route>
              <Route exact path={`${this.props.match.path}/`}>
                <>
                  <StoryList
                    userStories={this.props.userStoriesList}
                    projectId={projectId}
                    sprintId={sprintId}
                    sprint={sprint}
                  />
                </>
              </Route>
            </Switch>
          )}
        </LoadingComponent>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  sprintData: state.sprint.sprintInfo,
  projectData: state.project.data,
  userStoriesList: state.userStories.userStoriesList,
});
const mapDispatchToProps = (dispatch) => ({
  getProjectDetails: (projectId) => dispatch(getProjectDetails(projectId)),
  getSprintDetails: (projectId, sprintId) =>
    dispatch(getSprintDetails(projectId, sprintId)),
  getUserStories: (projectId, sprintId) =>
    dispatch(getUserStories(projectId, sprintId)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true }
  )(withStyles(style)(Sprint))
);
